import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-success-dialog',
  templateUrl: './success-dialog.component.html',
  styleUrls: ['./success-dialog.component.scss']
})
export class SuccessDialogComponent implements OnInit {
  @Input() public message: string = '';
  @Input() public title: string = '';
  @Input() public closeButtonLabel: string = 'Close';
  @Input() public viewButtonLabel: string = 'View';
  @Input() public showViewButton: boolean = false;
  @Output() nrbesSuccessPopupEmit: EventEmitter<any> = new EventEmitter();
  @Output() viewAction: EventEmitter<void> = new EventEmitter();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    if (this.title == '') {
      this.title = 'Success';
    }
  }

  get isSuccessState(): boolean {
    return this.title?.toLowerCase() !== 'error';
  }

  closeDialog() {
    this.nrbesSuccessPopupEmit.emit(null);
  }

  viewDialog() {
    this.viewAction.emit();
    this.nrbesSuccessPopupEmit.emit('view');
  }
}
